export function isInitChildMessage(message) {
    return message[0] === 'df-child' && message[1] === 'init';
}
export function isHeightMessage(message) {
    return message[0] === 'df-child' && message[1] === 'height';
}
export function isStateChangeMessage(message) {
    return message[0] === 'df-child' && message[1] === 'stateChange';
}
export function isCustomMessage(message) {
    return message[0] === 'df-child' && message[1] === 'custom';
}
export function isNotifMessage(message) {
    return message[0] === 'df-child' && message[1] === 'notif';
}
export function isReadyMessage(message) {
    return message[0] === 'df-child' && message[1] === 'ready';
}
export function isInitParentMessage(message) {
    return message[0] === 'df-parent' && message[1] === 'init';
}
export function isUpdateSrcMessage(message) {
    return message[0] === 'df-parent' && message[1] === 'updateSrc';
}
